import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import React from "react";

export const useHideOnPrint = (forceHide?: boolean, noOnClick?: boolean) => {
  const t = useTranslation();
  const [isVisible, setIsVisible] = React.useState(!forceHide);
  const displayedIcon = isVisible ? "fa:eye" : "fa:eye-slash";
  const className = isVisible ? "" : "no-print";
  const title = t(
    "maintenance:monitor.daily_schedule.print.ticket.message." +
      (isVisible ? "show" : "hide")
  );

  const toggleIsVisible = () => {
    if (forceHide) setIsVisible(false);
    else setIsVisible((prev) => !prev);
  };

  React.useEffect(() => {
    if (forceHide) setIsVisible(false);
  }, [forceHide]);

  const icon = (
    <Icon
      className="no-print"
      icon={displayedIcon}
      onClick={noOnClick ? undefined : toggleIsVisible}
      style={{ cursor: "pointer" }}
      title={title}
    />
  );

  return { className, icon, isVisible, toggleIsVisible, title };
};
